import { ReactNode } from 'react';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/material/styles';
import { Theme } from '@mui/material/styles';

export type TagProps = {
  text: ReactNode;
  disabled?: boolean;
  color?: string;
  backgroundColor?: string;
};

const TagChip = styled(Chip)(() => ({
  height: 'auto',
  borderRadius: 5,
  '& .MuiChip-label': {
    padding: '4.5px 16px',
    fontFamily: '"Poppins Medium", sans-serif',
    fontSize: 14,
    lineHeight: '19.6px',
    whiteSpace: 'nowrap',
  },
}));

const Tag = ({ text, disabled = false, backgroundColor, color }: TagProps) => (
  <TagChip
    label={text}
    disabled={disabled}
    sx={(theme: Theme) => {
      if (disabled) {
        return {
          borderRadius: 12,
          backgroundColor: theme.palette.neutral[10],
          color: theme.palette.neutral.black,
          opacity: 1,
          '& .MuiChip-label': {
            color: theme.palette.neutral.black,
          },
        };
      }
      const textColor = color ?? 'black';
      const fillColor = backgroundColor ?? '#faa3ba';
      return {
        backgroundColor: fillColor,
        color: textColor,
        '& .MuiChip-label': {
          color: textColor,
        },
      };
    }}
  />
);

export default Tag;
export { Tag };
